import React, { useEffect} from 'react';
import { HashLink } from 'react-router-hash-link';
import "./style.scss";

const PCHeader = () => {
    const [navbar, setNavar] = React.useState(false);

    const changeBackground = () => {
        if(window.scrollY >= 100) {
          setNavar(true);
        } else {
          setNavar(false);
        }
  
      };

    useEffect(() => {
      window.addEventListener("scroll", changeBackground);

    })

    return (
        <header>
            {navbar ? (
                <nav className="pc-title-header active">
                    <div className="pc-title-cn" to="/#top">
                        <a href="/">
                            <img src="/img/pc-title-black.png" />
                        </a>
                    </div>
                    <ol className="list-cn">
                        <li className="list">
                            <HashLink smooth to="/#top">홈</HashLink>
                        </li>
                        <li className="list">
                            <HashLink smooth to="/#02">화명동 바른정플란트치과</HashLink>
                        </li>
                        <li className="list">
                            <HashLink smooth to="/#03">의료진 소개</HashLink>
                        </li>
                        <li className="list">
                            <HashLink smooth to="/#04">진료과목</HashLink>
                        </li>
                        <li className="list">
                            <HashLink smooth to="/#05">바른정의 특별함</HashLink>
                        </li>
                        <li className="list">
                            <HashLink smooth to="/#06">바른정 안내</HashLink>
                        </li>
                    </ol>
                </nav>
            ): (
                <nav className="pc-title-header">
                    <div className="pc-title-cn">
                        <a href="/">
                            <img src="/img/pc-title-white.png" />
                        </a>
                    </div>
                    <ol className="list-cn">
                        <li className="list">
                            <HashLink smooth to="/#top">홈</HashLink>
                        </li>
                        <li className="list">
                            <HashLink smooth to="/#02">화명동 바른정플란트치과</HashLink>
                        </li>
                        <li className="list">
                            <HashLink smooth to="/#03">의료진 소개</HashLink>
                        </li>
                        <li className="list">
                            <HashLink smooth to="/#04">진료과목</HashLink>
                        </li>
                        <li className="list">
                            <HashLink smooth to="/#05">바른정의 특별함</HashLink>
                        </li>
                        <li className="list">
                            <HashLink smooth to="/#06">바른정 안내</HashLink>
                        </li>
                    </ol>
                </nav>
            )}
            
        </header>
    );
};

export default PCHeader;